import type { TermsConditionsContent } from '@/blocks/domain/types/BlockContent/ProseContent';
import { fromProseContent, mapProseContent, type ProseContentDtoFor } from '@/blocks/application/mappers/blockProseMapper';

export function mapTermsConditionsContent(dto: ProseContentDtoFor<'terms_conditions'>): TermsConditionsContent {
  return mapProseContent(dto) as TermsConditionsContent;
}

export function fromTermsConditionsContent(content: TermsConditionsContent): ProseContentDtoFor<'terms_conditions'> {
  return fromProseContent(content) as ProseContentDtoFor<'terms_conditions'>;
}
